import React, { useRef, useState } from "react";
import { useDrop } from "react-dnd";
import DraggableItem from "./DraggableItem";
import Quill from "./Quill";

const snapToGrid = (value, gridSize, gridColumns, width = 4) => {
  // console.log(value, gridSize, gridColumns, width);
  let gridUnits = Math.max(0, Math.round(value / gridSize), 0);

  if (gridColumns) {
    gridUnits = Math.min(gridColumns - width, gridUnits);
  }

  return gridUnits;
};

export default function DroppableArea({
  items,
  updateItemPosition,
  updateItemSize,
  handleDrop,
  sidebarWidth,
  isAsideCollapsed,
  handleRemoveItem,
  handleTitle,
  gridSize,
  gridColumns,
  dashboardSheetID,
  headerVisibilityArray,
  setHeaderVisibilityArray,
  isAnimataionOff,
  dashBgColor,
  grid = true,
}) {
  // console.log(items);
  // console.log(gridSize);
  const [showQuill, setShowQuill] = useState(false);
  const [quillContent, setQuillContent] = useState(null);
  const [isQuillEditing, setIsQuillEditing] = useState(null);

  const handleQuillSave = (content) => {
    setQuillContent(content);
  };

  const dropRef = useRef(null);

  const [{}, drop] = useDrop({
    accept: "ITEM",
    drop: (item, monitor) => {
      // console.log(item);

      const existingItemIndex = items.findIndex(
        (originalListItem) => originalListItem.Sheetid === item.Sheetid
      );
      const existingQuillItem = items.find(
        (originalListItem) => originalListItem.Sheetid === item.Sheetid
      );

      if (item.isParagraph && existingQuillItem === undefined) {
        setShowQuill(true);
        setIsQuillEditing(item.Sheetid);
      } else {
        setShowQuill(false);
      }

      const offset = monitor.getSourceClientOffset();
      let snappedX;
      let snappedY;
      let quillContent;
      let isParagraph;

      if (existingItemIndex > -1) {
        const offset = monitor.getDifferenceFromInitialOffset();
        snappedX = snapToGrid(
          offset.x + items[existingItemIndex].x * gridSize,
          gridSize,
          gridColumns,
          items[existingItemIndex].width
        );
        snappedY = snapToGrid(
          offset.y + items[existingItemIndex].y * gridSize,
          gridSize
        );
        quillContent = items[existingItemIndex].quillContent;
        isParagraph = items[existingItemIndex].isParagraph;
        // console.log(items[existingItemIndex]);
        // console.log(quillContent);

        updateItemPosition(
          item.Sheetid,
          snappedX,
          snappedY,
          quillContent,
          isParagraph
        );
      } else {
        snappedX = snapToGrid(
          offset.x - sidebarWidth,
          gridSize,
          gridColumns,
          item.width
        );
        snappedY = snapToGrid(offset.y, gridSize);
        handleDrop(
          item.Sheetid,
          snappedX,
          snappedY,
          item.SheetName,
          item.width,
          item.height,
          item.quillContent,
          item.isParagraph,
          item.SheetVizType,
          item.dataSourceID
        );
        if (item.Sheetid.includes("Quill")) {
          // console.log("quill is dropped");
        } else {
        }
      }
    },
  });

  return (
    <div
      ref={(node) => {
        drop(node);
        dropRef.current = node;
      }}
      className={`relative h-full overflow-hidden overflow-y-auto flex flex-wrap gap-4 border border-gray-200 rounded`}
      style={{
        backgroundSize: grid ? `${gridSize}px ${gridSize}px` : null,
        backgroundImage: grid
          ? `linear-gradient(to right, #e0e0e0 1px, transparent 1px), linear-gradient(to bottom, #e0e0e0 1px, transparent 1px)`
          : null,
        backgroundColor: dashBgColor,
      }}
    >
      {items.map((item) => (
        <MemoizedDraggableItem
          key={item.Sheetid}
          {...item}
          item={item}
          updateItemSize={updateItemSize}
          handleRemoveItem={handleRemoveItem}
          handleTitle={handleTitle}
          gridSize={gridSize}
          gridColumns={gridColumns}
          Sheetid={item.Sheetid}
          dashboardSheetID={dashboardSheetID}
          isHeaderVisible={
            headerVisibilityArray.includes(item.Sheetid) ? true : false
          }
          setHeaderVisibilityArray={setHeaderVisibilityArray}
          setIsQuillEditing={setIsQuillEditing}
          items={items}
          isAnimataionOff={isAnimataionOff}
          isParagraph={item.isParagraph}
        />
      ))}
      {isQuillEditing !== null || showQuill ? (
        <Quill
          handleQuillSave={handleQuillSave}
          closeModal={() => {
            setShowQuill(false);
            setIsQuillEditing(null);
          }}
          quillContent={quillContent}
          items={items}
          dashboardSheetID={dashboardSheetID}
          isQuillEditing={isQuillEditing}
          handleRemoveItem={handleRemoveItem}
        />
      ) : null}
    </div>
  );
}

const MemoizedDraggableItem = React.memo(
  DraggableItem,
  (prevProps, nextProps) => {
    // Check if the item size or position has changed
    // console.log(prevProps, nextProps);

    return (
      prevProps.x === nextProps.x &&
      prevProps.y === nextProps.y &&
      prevProps.width === nextProps.width &&
      prevProps.height === nextProps.height &&
      prevProps.gridSize === nextProps.gridSize &&
      prevProps.isHeaderVisible === nextProps.isHeaderVisible &&
      prevProps.quillContent === nextProps.quillContent &&
      prevProps.isParagraph === nextProps.isParagraph
    );
  }
);
